import { Box, Skeleton } from '@mui/material';

/**
 * @heading1: PipelineSkeleton Component
 * @paragraph: This component renders a skeleton UI placeholder for the pipeline view. It simulates the layout of pipeline columns and deals while data is being loaded.
 */
const PipelineSkeleton = () => {
    return (
    <Box
        sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            p: 2,
            overflowX: 'auto'
        }}
    >
        {/* Skeleton for each column */}
        {[1, 2, 3, 4, 5, 6].map((_, index) => (
            <Box
                key={index}
                sx={{
                    bgcolor: 'white',
                    width: 250,
                    height: 300,
                    p: 2,
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)'
                }}
            >
                {/* Title Skeleton */}
                <Skeleton
                    variant="text"
                    sx={{ fontSize: '1.25rem', width: '70%' }}
                />
                <Skeleton variant="text" sx={{ fontSize: '0.9rem', width: '90%' }} />

                {/* Deal count skeleton */}
                <Skeleton
                    variant="text"
                    sx={{ fontSize: '1rem', width: '50%' }}
                />

                {/* Placeholder for card items */}
                <Box
                    sx={{
                        flex: 1,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                        gap: 2
                    }}
                >
                    <Skeleton
                        variant="rectangular"
                        sx={{ width: '90%', height: '100px', borderRadius: 1 }}
                    />
                    <Skeleton
                        variant="rectangular"
                        sx={{ width: '60%', height: '40px', borderRadius: 1 }}
                    />
                </Box>

                {/* Add Deal Button Skeleton */}
                <Skeleton
                    variant="rectangular"
                    sx={{ width: '80%', height: '40px', borderRadius: 20 }}
                />
            </Box>
        ))}
    </Box>
    );
};

export default PipelineSkeleton;